import React from 'react'
import styled from 'styled-components'

import appStoreImg from '../images/App_Store.png'
import playStoreImg from '../images/Play_Store.png'

const Icons = styled.div`
  display: flex;
  margin-top: 30px;
  justify-content: flex-start;
`

const IconLink = styled.a`
  display: block;
  margin-right: 20px;

  &:last-of-type {
    margin-right: 0;
  }
`

const IconImg = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`

const AppStores = () => (
  <Icons>
    <IconLink href={'https://apps.apple.com/at/app/id1125060405'} target="_blank" rel="noopener noreferrer">
      <IconImg src={appStoreImg} alt="App Store" width="190" height="60" />
    </IconLink>
    <IconLink href={'https://c00.adobe.com/v3/1439d9877f418a489fcb07a5456289e01a00aeb3702e57bdd36fc538e9789886/start?a_dl=5b4d421f7a96dbf419dfb742'} target="_blank" rel="noopener noreferrer">
      <IconImg
        src={playStoreImg}
        alt="Google Play Store"
        width="190"
        height="60"
      />
    </IconLink>
  </Icons>
)

export default AppStores
